export default "__VITE_ASSET__CYDrtCVx__"